import {
  Paper as MuiPaper,
  Table as MuiTable,
  Tooltip as MuiTooltip,
  TableRow as MuiTableRow,
  TableBody as MuiTableBody,
  TableCell as MuiTableCell,
  TableHead as MuiTableHead,
  Typography as MuiTypography,
  TableContainer as MuiTableContainer,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { Theme } from "common";

// Destination Submission Table for Copy Submission Dialog
export const DestinationSubmissionTable = ({ destinationSubValue }) => {
  const { t } = useTranslation();

  return (
    <MuiTableContainer component={MuiPaper}>
      <MuiTable aria-label="commitment-table">
        <MuiTableHead sx={{ background: Theme.palette.primary.light }}>
          <MuiTableRow>
            <MuiTableCell width="140px">
              <MuiTypography variant="subtitle1" noWrap>
                {t("submission.copy.tableColumns.monthYear")}
              </MuiTypography>
            </MuiTableCell>
            <MuiTableCell width="140px">
              <MuiTypography variant="subtitle1" noWrap>
                {t("submission.copy.tableColumns.spo")}
              </MuiTypography>
            </MuiTableCell>
            <MuiTableCell width="160px">
              <MuiTypography variant="subtitle1" noWrap>
                {t("submission.copy.tableColumns.award")}
              </MuiTypography>
            </MuiTableCell>
            <MuiTableCell>
              <MuiTypography variant="subtitle1" noWrap>
                {t("submission.copy.tableColumns.title")}
              </MuiTypography>
            </MuiTableCell>
          </MuiTableRow>
        </MuiTableHead>
        <MuiTableBody>
          <MuiTableRow>
            <MuiTableCell>
              <MuiTypography variant="body2" noWrap>
                {destinationSubValue?.monthYear || t("globals.notAvailable")}
              </MuiTypography>
            </MuiTableCell>
            <MuiTableCell>
              <MuiTypography variant="body2" noWrap>
                {destinationSubValue?.spo || t("globals.notAvailable")}
              </MuiTypography>
            </MuiTableCell>
            <MuiTableCell>
              <MuiTooltip
                title={destinationSubValue?.award || t("globals.notAvailable")}
              >
                <MuiTypography variant="body2" noWrap>
                  {destinationSubValue?.award || t("globals.notAvailable")}
                </MuiTypography>
              </MuiTooltip>
            </MuiTableCell>
            <MuiTableCell>
              <MuiTooltip
                title={destinationSubValue?.title || t("globals.notAvailable")}
              >
                <MuiTypography
                  variant="body2"
                  noWrap
                  sx={{ maxWidth: "540px" }}
                >
                  {destinationSubValue?.title || t("globals.notAvailable")}
                </MuiTypography>
              </MuiTooltip>
            </MuiTableCell>
          </MuiTableRow>
        </MuiTableBody>
      </MuiTable>
    </MuiTableContainer>
  );
};
